import ContentCopy from './ContentCopy'
import { ContentFulPageProps } from '../types'
import ContentImage from './ContentImage'
import styles from './styles.module.scss'
import { ButtonLink } from '@components/ui/Button'
import classNames from 'classnames'
import { useMediaQuery } from '@helpers/hooks'
import { BREAKPOINT_SIZES } from '@consts/index'
import ImageCopySectionContainerMobile from './MobileContent'

export default function ImageCopySectionContainer({
  copy,
  makeCopyPrimaryColor = false,
  copyBackgroundTransparent,
  copyPosition,
  imageMobile,
  imageDesktop,
  imageDesktopLarge,
  title,
  titleSize,
  button,
  icon
}: ContentFulPageProps) {
  const normalizedCopyPosition = copyPosition || 'right'
  const normalizedTitleSize = titleSize || 'M'

  const isDesktop = useMediaQuery({
    minWidth: BREAKPOINT_SIZES.DESKTOP,
    initialState: true
  })
  const isSolidBackground = !copyBackgroundTransparent

  const backgroundColor = isSolidBackground ? '#ffffff' : 'transparent'
  const copyColor = makeCopyPrimaryColor ? '#001e3c' : '#ffffff'

  const containerClass = classNames(
    styles.ImageCopySectionContainer,
    styles[normalizedCopyPosition],
    {
      [styles.ImageCopySectionContainer__grid]: isSolidBackground
    }
  )

  if (isDesktop) {
    return (
      <div
        className={containerClass}
        style={
          {
            '--background-color': backgroundColor,
            '--copy-color': copyColor
          } as React.CSSProperties
        }
      >
        <ContentImage
          imageDesktop={imageDesktop}
          imageDesktopLarge={imageDesktopLarge}
          imageMobile={imageMobile}
          useGridLayout={isSolidBackground}
          classes={styles.ImageCopySectionContainer__galleryWrapper}
        />

        <div className={styles.ImageCopySectionContainer__wrapper}>
          {!isSolidBackground && <div />} {/* spacer */}
          <div className={styles.ImageCopySectionContainer__content}>
            <div className={styles.ImageCopySectionContainer__contentContainer}>
              <h2
                className={classNames(
                  styles.ImageCopySectionContainer__sectionTitle,
                  styles[`titleSize--${normalizedTitleSize}`]
                )}
              >
                {title}
              </h2>

              <ContentCopy copy={copy.content}>
                {button && (
                  <ButtonLink
                    href={button.uri}
                    variant={button.buttonStyle}
                    classes={styles.ImageCopySectionCopy__contentButton}
                  >
                    {button.text}
                  </ButtonLink>
                )}
                {icon && (
                  <div className={styles.ImageCopySectionCopy__inlineSVG}>
                    <div
                      className={styles.svgIcon}
                      style={
                        {
                          maskImage: `url(${icon.url})`,
                          WebkitMaskImage: `url(${icon.url})`,
                          '--svgIcon-width': `${icon.width}px`,
                          '--svgIcon-height': `${icon.height}px`
                        } as React.CSSProperties
                      }
                    />
                  </div>
                )}
              </ContentCopy>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div
      className={containerClass}
      style={
        {
          '--background-color': backgroundColor,
          '--copy-color': copyColor
        } as React.CSSProperties
      }
    >
      <ImageCopySectionContainerMobile
        copy={copy}
        copyBackgroundTransparent={copyBackgroundTransparent}
        imageDesktopLarge={imageDesktopLarge}
        imageDesktop={imageDesktop}
        imageMobile={imageMobile}
        title={title}
        titleSize={normalizedTitleSize}
        button={button}
        icon={icon}
      />
    </div>
  )
}
